module.exports = __webpack_public_path__ + "img/logo-full.2d58b7c6.svg";